import request from '../../utils/request'
const urlParams = process.env.VUE_APP_UPLOAD_REAL_PATH
export default {
  // 养老食堂分类新增
  foodClassAddUp(data) {
    const params = data
    return request({
      url: urlParams + '/canteen-food-category/addUp',
      type: 'post',
      params: params,
      qs:false
    })
  },  
  // 养老食堂分类列表
  foodClassList(data) {
    const params = data
    return request({
      url: urlParams + '/canteen-food-category/list',
      type: 'get',
      params: params
    })
  },  
  // 养老食堂分类删除
  foodClassDel(data) {
    const params = data
    return request({
      url: urlParams + '/canteen-food-category/del',
      type: 'post',
      params: params
    })
  },   
  // 养老食堂食物列表
  foodList(data) {
    const params = data
    return request({
      url: urlParams + '/canteen-food/list',
      type: 'get',
      params: params
    })
  },     
  // 养老食堂食物新增
  foodAddUp(data) {
    const params = data
    return request({
      url: urlParams + '/canteen-food/addUp',
      type: 'post',
      params: params,
      qs:false
    })
  },   
  // 养老食堂食物删除
  foodDel(data) {
    const params = data
    return request({
      url: urlParams + '/canteen-food/del',
      type: 'post',
      params: params
    })
  }, 
  // 养老食堂食物上下架
  foodUpdateStatus(data) {
    const params = data
    return request({
      url: urlParams + '/canteen-food/updateStatus',
      type: 'post',
      params: params
    })
  },   
  // 养老食堂订单列表
  canteenOrderList(data) {
    const params = data
    return request({
      url: urlParams + '/order-main-canteen/list',
      type: 'get',
      params: params
    })
  },  
  // 养老食堂取消订单
  canteenOrderCancel(data) {
    const params = data
    return request({
      url: urlParams + '/order-main-canteen/cancel',
      type: 'post',
      params: params
    })
  },       
}